import { render, staticRenderFns } from "./singleBankBalancePanel.vue?vue&type=template&id=48b76bb0"
import script from "./singleBankBalancePanel.vue?vue&type=script&lang=js"
export * from "./singleBankBalancePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports